import Vue from 'vue'

import WysiwygMixin from '../wysiwyg_mixin'
import ModalMixin from '../modal_mixin'

import lang from 'element-ui/lib/locale/lang/ja'
import locale from 'element-ui/lib/locale'
import 'element-ui/lib/theme-chalk/index.css'
import '../../../../../sass/common/element-variables.scss'
import ElementUIHelper from '../../../element-ui-helper'

locale.use(lang)

export default (data) => {

  // Summernote用の設定
  data.uploadImageUrl = '/admin/news/upload_img'
  data.uploadFileUrl = '/admin/news/upload_img'
  data.csrfToken = document.head.querySelector('meta[name="csrf-token"]').content
  data.errors = data.errors || {}
  // WYSIWYGミックスイン用の初期値
  data.wysiwygSelectedFileName = data.wysiwygSelectedFileName || null

  data.disabled = data.mode === 'show'

  const vm = new Vue({
    el: '#customer-content',
    mixins: [WysiwygMixin, ModalMixin],
    data() {
      return data;
    },
    mounted() {
      // open_flgがtrueの場合のみSummernoteを初期化
      if (this.policy && this.policy.open_flg) {
        this.$nextTick(() => {
          this.initSummernote('#wysiwyg_editor', {
            styleTags: ['p', 'h2', 'h3', 'h4'],
            styleLabels: {
              p: '標準',
              h2: 'ヘッダー2',
              h3: 'ヘッダー3',
              h4: 'ヘッダー4',
            },
            hideButtons: ['customPicture', 'uploadFile']
          })
          // Summernoteエディタ内の要素に対してtooltipを無効化
          this.disableTooltipInSummernote();
        })
      }
      
      if (data.disabled) {
        $(':input').prop('disabled', true);
        $('input[type="button"],button[type="button"]').prop('disabled', false);
      }
    },
    watch: {
      'policy.open_flg'(newVal) {
        // open_flgがtrueになったときにSummernoteを初期化
        if (newVal && !this.editor) {
          this.$nextTick(() => {
            this.initSummernote('#wysiwyg_editor', {
              styleTags: ['p', 'h2', 'h3', 'h4'],
              styleLabels: {
                p: '標準',
                h2: 'ヘッダー2',
                h3: 'ヘッダー3',
                h4: 'ヘッダー4',
              },
              hideButtons: ['customPicture', 'uploadFile']
            })
            // Summernoteエディタ内の要素に対してtooltipを無効化
            this.disableTooltipInSummernote();
          })
        }
        // open_flgがfalseになったときにSummernoteを破棄
        if (!newVal && this.editor) {
          this.editor.summernote('destroy');
          this.editor = null;
        }
      }
    },
    methods: {
      onChangePageOpen(event) {
        this.modal = $('#dialog_publish');
        this.modal.modal('show');
      },
      modalCancel(event) {
        this.modal = $('#dialog_publish');
        if (this.policy.open_flg) {
          this.policy.open_flg = false;
        } else {
          this.policy.open_flg = true;
        }
        this.modal.modal('hide');
      },
      modalSettings(event) {
        this.modal = $('#dialog_publish');
        this.modal.modal('hide');
      },
      saveContent() {
        // Summernoteのコンテンツをクリーンアップして保存
        if (this.editor) {
          // Vueモデルとtextareaに反映
          const cleanedContent = this.getCleanContent()
          this.policy.contents = cleanedContent
          this.editor.summernote('code', cleanedContent)
        }
      },
      updateComment(contents) {
        // WYSIWYGエディタの内容をVueモデルに反映
        this.policy.contents = contents
      },
      disableTooltipInSummernote() {
        // Summernoteエディタ内の要素に対してtooltipを無効化
        if ($.ui && $.ui.tooltip) {
          const $editor = this.editorElement.next('.note-editor');
          if ($editor.length) {
            // Summernoteエディタ内のすべての要素に対してtooltipを無効化
            $editor.find('[title]').each(function() {
              $(this).tooltip('disable');
            });
            // 新しく追加される要素にも対応（MutationObserverを使用）
            if (window.MutationObserver) {
              const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                  mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === 1) { // Element node
                      const $node = $(node);
                      $node.find('[title]').addBack('[title]').each(function() {
                        $(this).tooltip('disable');
                      });
                    }
                  });
                });
              });
              observer.observe($editor[0], {
                childList: true,
                subtree: true
              });
              // コンポーネントが破棄されるときにobserverを切断
              this.$once('hook:beforeDestroy', () => {
                observer.disconnect();
              });
            }
          }
        }
      },
    }
  })
}
